import { Form } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CommonInputText from '../components/CommonInputText';
import { Reminder } from '../models/dashboard-models';
import { AddEditProps } from '../models/table-models';
import { fetchRemindersYours, useAddReminder } from '../utils/dashboard-hooks';
import DatePicker from 'react-datepicker';
import { resourceCache } from 'use-async-resource';
import {toast} from "react-toastify";
import {CustomToastContent} from "../components/CustomToastContent";
import {toastOptionsTopRight} from "../utils/Enums/ToastOptions";
import React from "react";

export const CustomTimeInput = ({ value, onChange }: { value?: any; onChange?: any }) => {
    return (
        <div className=' position-relative w-100'>
            <input
                onChange={(e) => {
                    onChange(e.target.value);
                }}
                {...{ value }}
                className='d-block px-2 py-1 text-center border border-dark rounded'
                type='time'
                id='timePicker'
            />
        </div>
    );
};

export const AddReminder = ({ setShowModal, itemRelatedId, refetchEntitiesHook }: AddEditProps<Reminder>) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { control, register, handleSubmit, formState } = useForm<Reminder>({
        mode: 'all',
        defaultValues: {
            endTime: new Date(),
        },
    });

    const useSubmitHandlerAdd = async (formValue: Reminder) => {
        await useAddReminder({ ...formValue, branchId: itemRelatedId });
        resourceCache(fetchRemindersYours).clear();
        refetchEntitiesHook();
        setShowModal(false);
        toast.success(<CustomToastContent content={[t('remainderSuccess')]} />, toastOptionsTopRight);
    };

    return (
        <Form
            id='form'
            className='d-flex flex-column align-items-center p-4  w-100'
            noValidate
            onSubmit={handleSubmit(useSubmitHandlerAdd)}
        >
            <p className='d-block w-100 my-1'>Date</p>
            <Form.Group
                className=' d-flex flex-column mb-0 align-items-start w-100 rounded timer-picker'
                controlId='endTime'
            >
                <Controller
                    control={control}
                    name='endTime'
                    rules={{ required: true }}
                    render={({ field }) => (
                        <DatePicker
                            onChange={(e) => {
                                field.onChange(e);
                            }}
                            timeInputLabel='Time:'
                            showTimeInput
                            selected={field.value}
                            startDate={new Date()}
                            placeholderText='Date'
                            dateFormat='dd/MM/yyyy HH:mm'
                            timeFormat='HH:mm'
                            className='border border-dark px-1 py-2 my-2 rounded w-100 '
                            onChangeRaw={(e) => {
                                e.preventDefault();
                            }}
                            customTimeInput={
                                <CustomTimeInput
                                    onChange={field.onChange}
                                    value={field.value.toString()}
                                ></CustomTimeInput>
                            }
                        ></DatePicker>
                    )}
                />
            </Form.Group>
            <Form.Group className=' d-flex flex-column mb-0 align-items-start w-100 ' controlId='comment'>
                <CommonInputText
                    id='comment'
                    label={t('comment')}
                    labelTextColor='text-black'
                    type='text'
                    fieldError={formState.errors.endTime}
                    hookRegister={register('comment', {
                        required: {
                            value: true,
                            message: t('comment'),
                        },
                    })}
                />
            </Form.Group>
        </Form>
    );
};
